<template>
  <VueContentLoading
    :primary="$scss.colors.cardBg"
    :secondary="$scss.colors.inputBg"
  />
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'DefaultLoader',
  components: {
    VueContentLoading,
  },
};
</script>
